<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <div class="allinea-rose">
      <v-card>
        <v-card-title class="warning headline">
          <span class="white--text" v-if="!isSquadreAllineate"
            >Disallineamento squadre</span
          >
          <span class="white--text" v-else-if="!isCalciatoriAllineati"
            >Disallineamento rose</span
          >
          <span class="white--text" v-else>Riallineamento rose/crediti</span>
          <v-spacer></v-spacer>
          <v-btn fab depressed outlined small color="white" @click="retry">
            <v-icon>sync</v-icon>
          </v-btn>
          <v-btn depressed class="white--text" icon @click="dismiss">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <div class="pa-4">
          <div v-if="!isSquadreAllineate">
            <v-alert dense text type="error" class="mt-3 mb-0">
            C'è un disallineamento tra le squadre iscritte alla lega e quelle
            attualmente visibili in Asta Live. <strong>Devi riallineare.</strong>
            </v-alert>

          </div>
          <div v-else-if="!isCalciatoriAllineati">

          <v-alert dense text type="default" class="mt-3 mb-0">
            <strong>Dovresti riallineare</strong> le rose/crediti.<br><br>

            Rose e crediti che vedi su Asta Live sono diversi da quelli <a :href="roseLegaUrl" target="_blank">che adesso vedi su app/sito</a>. <br>
            È una cosa del tutto normale: succede se avete fatto dei movimenti di mercato (o modificato manualmente i crediti) al di
            fuori di Asta Live (es: tramite Assegna/Svincola manuale, AstaEbay ecc.). Prima di procedere a utilizzare Asta Live dovresti riallineare (ovvero sovrascrivere) le rose di Asta Live in modo che tutto sia di nuovo uguale ad app/sito e sia il punto di partenza per avviare l'asta ;)

            <br><br>
            Cosa succede se non riallinei?

            <br>Asta Live potrebbe assegnare un calciatore che su sito/app non era tra gli svincolati ma era già in una rosa.
            Quindi, quando alla fine dell'asta in Asta Live andrai a "Salvare Assegnazioni/Rose", il sistema ti darà errore perché un calciatore risulterà non assegnabile in quanto non svincolato.

             </v-alert>

            <v-alert dense text type="info" class="mt-3 mb-0">
              Se non hai ancora mai usato Asta Live, puoi riallineare senza problemi.
              Se invece avevi già avviato Asta Live e ci sono assegnazioni NON ANCORA SALVATE definitivamente su app/sito,
              <strong>assicurati di segnarti quelle assegnazioni a mano o andranno perse</strong> quando riallinerai.
            </v-alert>
          </div>
          <div v-else>
            Asta Live ci sembra già allineata con rose/crediti
            <a :href="roseLegaUrl" target="_blank">che adesso vedi sul sito/app</a>.
            Volendo potresti comunque forzare un riallineamento.<br>
            <v-alert dense text type="info" class="mt-3 mb-0">
              Se non hai ancora mai usato Asta Live, puoi riallineare senza problemi.
              Se invece avevi già avviato Asta Live e ci sono assegnazioni NON ANCORA SALVATE definitivamente su app/sito,
              <strong>assicurati di segnarti quelle assegnazioni a mano o andranno perse</strong> quando riallinerai.
            </v-alert>
          </div>
          <div class="table-comparisons" v-if="!isCalciatoriAllineati">
            <table :class="{ 'nice-scroll': !is_mobile }">
              <thead>
                <tr>
                  <th></th>
                  <th>Asta Live</th>
                  <th>App/Sito</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(obj, id_calciatore) in comparisons"
                  :key="id_calciatore"
                >
                  <td>
                    <b>{{ calciatori[id_calciatore].calciatore }}</b>
                    <!-- <calciatore hideImages :id="id_calciatore"></calciatore> -->
                  </td>

                  <td>
                    <div class="d-flex justify-left align-center">
                      <!-- <squadra-crediti
                      v-if="obj.pre"
                      :id="obj.pre.squadra_id"
                      :crediti="obj.pre.p"
                      showCrediti
                      xSmall
                    ></squadra-crediti> -->
                      <div v-if="obj.pre">
                        {{ asta_squadre[obj.pre.squadra_id].name }} ({{
                          obj.pre.p
                        }})
                      </div>
                      <div v-else>Svincolato</div>
                    </div>
                  </td>

                  <td>
                    <div class="d-flex justify-left align-center">
                      <!-- <squadra-crediti
                      v-if="obj.post"
                      :id="obj.post.squadra_id"
                      :crediti="obj.post.p"
                      showCrediti
                      xSmall
                    ></squadra-crediti> -->
                      <div v-if="obj.post">
                        {{ asta_squadre[obj.post.squadra_id].name }} ({{
                          obj.post.p
                        }})
                      </div>
                      <div v-else>Svincolato</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <v-divider></v-divider>
        <div class="d-flex justify-center align-center">
          <v-btn
            rounded
            depressed
            color="warning"
            class="ma-2"
            @click="allineaRose"
          >
            Riallinea
          </v-btn>
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import Config from "../../../config-app/config";
import CalciatoreComparison from "../common/CalciatoreComparison";
import Calciatore from "../common/Calciatore";
import SquadraCrediti from "../common/SquadraCrediti";

export default {
  name: "allinea-rose",
  mixins: [mixins],
  components: { CalciatoreComparison, Calciatore, SquadraCrediti },
  data() {
    return {
      responsed: false,
      forceDialogOnResponse: false,
      comparisons: {},
      isSquadreAllineate: true,
    };
  },
  mounted() {
    console.log("--> AllineaRose ready.");
    db.on("checkAllineamentoRose", this.checkAllineamentoRose);
    db.on("handleApiCallSuccess", this.handleApiCallSuccess);
    window._promptImportRose = this.promptImportRose;
  },
  destroyed() {
    console.log("<-- AllineaRose destroyed.");
    db.off("checkAllineamentoRose", this.checkAllineamentoRose);
    db.off("handleApiCallSuccess", this.handleApiCallSuccess);
  },
  methods: {
    checkAllineamentoRose(forceDialogOnResponse) {
      this.reset();
      this.forceDialogOnResponse = forceDialogOnResponse;
      this.api();
    },
    handleApiCallSuccess(apiName) {
      if (apiName == "importRose") {
        this.astaLogRoseImported();
        this.dismiss();
      }
    },
    dismiss() {
      this.reset();
    },
    reset() {
      this.responsed = false;
      this.forceDialogOnResponse = false;
      this.comparisons = {};
      this.isSquadreAllineate = true;
    },
    retry() {
      this.dismiss();
      this.checkAllineamentoRose(true);
    },
    // tryDismiss() {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Attenzione",
    //     text: "Non puoi proseguire finchè non risolvi questo disallineamento tra le rose di asta live e quelle del sito/app",
    //   });
    // },
    arraysHaveSameElements(arr1, arr2) {
      return (
        arr1.length === arr2.length &&
        new Set(arr1.concat(arr2)).size === arr1.length
      );
    },
    convert(asta_squadre) {
      let output = {};
      for (let squadra_id in asta_squadre) {
        if (asta_squadre[squadra_id].calciatori) {
          for (let id_calciatore in asta_squadre[squadra_id].calciatori) {
            output[id_calciatore] =
              asta_squadre[squadra_id].calciatori[id_calciatore];
            output[id_calciatore]["squadra_id"] = squadra_id;
          }
        }
      }
      return output;
    },
    prePost(pre, post, note = null) {
      return {
        pre: pre,
        post: post,
        note: note,
      };
    },
    async api() {
      try {
        let endpoint = "/firebase_import_rose.php";
        let params = {
          params: {
            uid: this.user_claims.fp_uid,
            sessid: this.user_claims.fp_sessid,
            token: Config.API_TOKEN,
            ID_Asta: this.asta_info.id,
            preview: 1,
          },
        };

        this.$Progress.start();
        let calciatoriS;
        let squadreS;
        let calciatoriF;
        let squadreF;
        let response = await this.$http.get(
          Config.API_ENDPOINT + endpoint,
          params
        );

        let json = response.body;
        if (json.status == 1) {
          squadreS = Object.keys(json.data);
          calciatoriS = this.convert(json.data);
        } else {
          throw Error(json.msg);
        }
        squadreF = Object.keys(this.asta_squadre);
        calciatoriF = this.convert(this.asta_squadre);

        if (!this.arraysHaveSameElements(squadreS, squadreF)) {
          this.isSquadreAllineate = false;
          // nn ho bisogno di controllare i singoli calciatori, mancano delle squadre!
        } else {
          // comparazione calciatoriS - calciatoriF
          let _comparisons = {};
          // prima controllo le rose in asta live (F = Firebase)
          for (let id_calciatore in calciatoriF) {
            // se esiste nel listone
            if (this.calciatori[id_calciatore]) {
              let calciatoreF = calciatoriF[id_calciatore];

              let calciatoreS = calciatoriS[id_calciatore];
              // mi preoccupo solo di quelli che nn esistono nelle rose server
              // perchè quelli che esistono saranno gestiti dal loop successivo
              if (!calciatoreS) {
                // se è i=1 devo cancellarlo
                // (succede se vendo un calciatore su app dopo che ho allineato le rose)
                if (calciatoreF.i == 1) {
                  _comparisons[id_calciatore] = this.prePost(
                    calciatoreF,
                    null,
                    "Svincolato"
                  );
                } else {
                  // sennò lo posso lasciare in Asta Live
                }
              }
            } else {
              // todo
            }
          }
          for (let id_calciatore in calciatoriS) {
            // se esiste nel listone
            if (this.calciatori[id_calciatore]) {
              let calciatoreS = calciatoriS[id_calciatore];
              let calciatoreF = calciatoriF[id_calciatore];

              if (!_.isEqual(calciatoreS, calciatoreF)) {
                if (!calciatoreF) {
                  // se nn esiste in asta live, vuol dire che è semplicemente un acquisto
                  // lo aggiungo alla tabella ma senza note
                  _comparisons[id_calciatore] = this.prePost(null, calciatoreS);
                } else {
                  // se esiste
                  // a prensincere se calciatoreF.i = 0/1, lo sovrascrivo cn "1" senza informare l'utente)
                  let note = null;
                  if (
                    calciatoreF.squadra_id != calciatoreS.squadra_id &&
                    calciatoreF.p != calciatoreS.p
                  ) {
                    note = "Modificati squadra e costo";
                  } else if (calciatoreF.squadra_id != calciatoreS.squadra_id) {
                    note = "Modificata squadra";
                  } else if (calciatoreF.p != calciatoreS.p) {
                    note = "Modificato costo";
                  }
                  _comparisons[id_calciatore] = this.prePost(
                    calciatoreF,
                    calciatoreS,
                    note
                  );
                }
              }
            } else {
              // todo
            }
          }
          this.comparisons = _comparisons;
        }
        this.$Progress.finish();
        this.responsed = true;
      } catch (error) {
        this.$Progress.fail();
        Swal.fire({
          icon: "error",
          title: "Errore inatteso",
          html: error,
        });
      }
    },
    async allineaRose() {
      // delego il server per questo controllo
      // if (!this.admin) {
      //   // workaround senza squadre!!!
      //   if (_.size(this.asta_squadre) > 0) {
      //     db.emit("swalAdmin");
      //     return;
      //   }
      // }
      if (this.isAstaInCorso) {
        db.emit("swalAstaInCorso");
        return;
      }

      db.emit("showImportRose");
    },
  },
  computed: {
    isCalciatoriAllineati() {
      return Object.keys(this.comparisons).length === 0;
    },
    roseLegaUrl() {
      return (
        Config.HOST +
        "/fantacalcio/rose-lega/" +
        this.asta_info.lega.ID_Lega +
        "/" +
        this.asta_info.lega.ID_Divisione
      );
    },
    dialog() {
      if (
        this.responsed &&
        (!this.isCalciatoriAllineati ||
          !this.isSquadreAllineate ||
          this.forceDialogOnResponse)
      ) {
        return true;
      } else {
        return false;
      }
    },
    ...Vuex.mapGetters(["calciatori", "is_mobile", "asta_squadre"]),
  },
};
</script>
<style lang="scss" scoped>
.table-comparisons {
  height: 200px;
  overflow: auto;
  table {
    width: 100%;
    margin: 10px 0;
    font-size: 13px;
    color: var(--v-text-darken2);
    th {
      text-align: left;
      padding: 5px;
    }
    td {
      padding: 5px;
    }
  }
}

.calciatore {
  box-shadow: none;
  margin: 0;
}
</style>
